module.exports = __webpack_public_path__ + "static/media/m-bg-3.bd395511.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/m/m-bg-3.png
// module id = 56
// module chunks = 3